import {cn} from 'cn';

const moneyFormat = new Intl.NumberFormat('ru-RU', {
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
});

const unitsFormat = new Intl.NumberFormat('ru-RU', {
	maximumFractionDigits: 2,
});

export function formatUnits(value: number): string {
	return unitsFormat.format(value);
}

export function formatFlow(value: number | null, asExpense = false, percent = false): string {
	if (value == null) return '—';
	const signed = asExpense ? -Math.abs(value) : value;
	const amount = moneyFormat.format(Math.abs(signed));
	const unit = percent ? '%' : '₽';
	if (signed > 0) return `+${amount} ${unit}`;
	if (signed < 0) return `−${amount} ${unit}`;
	return `${amount} ${unit}`;
}

export function flowAmountClassName(value: number | null, asExpense = false): string {
	if (value == null) return 'text-muted-foreground';
	const signed = asExpense ? -Math.abs(value) : value;
	if (signed > 0) return 'text-green-600 dark:text-green-500';
	if (signed < 0) return 'text-destructive';
	return 'text-foreground';
}

export const FLOW_VALUE_WIDTH_CLASS = 'w-[118px] shrink-0 tabular-nums text-right';

export function flowRowClassName(total: boolean): string {
	return cn(
		'flex items-baseline gap-3',
		total && 'mt-2 border-t border-border pt-2',
	);
}
